// removed by extract-text-webpack-plugin
module.exports = {"field-cell":"add-category-modal__field-cell___3IoJ1","fields":"add-category-modal__fields___3vezM","button-container":"add-category-modal__button-container___3-G5b"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-categories/add-category-modal.scss
// module id = 516
// module chunks = 0